import { baseKeyMap } from '../../types/keyboardKeys'
import {
  GcomeCalibrationValue,
  keyboardCalibration,
  KeyTravelList,
  KeyTravelWriteList,
  protocolCailbrationType,
} from '../../types/keyTravel'
import { FeatureBase } from '../FeatureBase'

// 扩展功能注册表
declare module '../FeatureMap' {
  export interface DeviceFeatureMap {
    keyTravel: IKeyTravelFeature
  }
}

export interface IKeyTravelFeature {
  // 获取全局RT配置
  getGlobalRTConfig(): Promise<number>
  // 设置全局RT配置
  setGlobalRTConfig(index: number): Promise<void>
  // 获取键盘所有键位的单键程及死区
  getKeyTravel(rt: number): Promise<KeyTravelList>
  // 流式获取键盘所有键位的单键程及死区
  getKeyTravelStream(rt: number, batchSize?: number): AsyncIterable<KeyTravelList>
  // 设置指定键位表的单键程及死区
  setKeyTravel(keyTravelList: KeyTravelWriteList, index?: number): Promise<void[] | void>
  // 获取所有键位轴体类型（GCOME_AP 特有）
  getKeyShaftTypes(): Promise<Array<{ index: number; shaftType: number }>>
  // 批量设置键位轴体类型（GCOME_AP 特有）
  setKeyShaftTypes(entries: Array<{ index: number; shaftType: number }>): Promise<void>
  // 获取指定键位的轴体类型 ID（GCOME_AP 特有）
  getKeyShaftType(keyIndex: number): Promise<number>
  // 设置指定键位的轴体类型 ID（GCOME_AP 特有）
  setKeyShaftType(keyIndex: number, shaftType: number): Promise<void>
  // 读取按键校准数据（GCOME_AP 特有，CMD 0xaa，128 键 × IEEE754）
  getCalibrationValues(): Promise<GcomeCalibrationValue[]>
  // 快速获取校准值（GCOME_AP 特有，CMD 0xa9 结束校准响应）
  getCalibrationValuesQuick(): Promise<GcomeCalibrationValue[]>
  // 读取按键校准次数（GCOME_AP 特有，GetBase 偏移 128，0xff=完成）
  getCalibrationCounts(): Promise<number[]>

  // getKeyTravel 返回带 family 的判别联合：classic = CH585M/OHID，gcome = GCOME_AP。
  // GCOME 写入允许 Partial<GcomeKeyTravel> 补丁（实现内读-改-写合并）。

  // 切换演示模式
  switchDemoMode(state: boolean): Promise<void>
  // 切换键盘校准模式
  switchCalibrationMode(state: boolean, options?: keyboardCalibration): Promise<void>
  // 协议校准
  calibration(type: protocolCailbrationType, keyList?: baseKeyMap): Promise<void>
  // 保存协议校准数据
  saveCalibration(type: protocolCailbrationType): Promise<void>
  // 切换自适应校准
  switchAdaptiveCalibration(state: boolean): Promise<void>
}

export class KeyTravelFeature extends FeatureBase implements IKeyTravelFeature {
  getGlobalRTConfig(): Promise<number> {
    return this.unsupported('KeyTravelFeature.getGlobalRTConfig')
  }
  setGlobalRTConfig(_index: number): Promise<void> {
    return this.unsupported('KeyTravelFeature.setGlobalRTConfig')
  }
  getKeyTravel(_rt: number): Promise<KeyTravelList> {
    return this.unsupported('KeyTravelFeature.getKeyTravel')
  }
  getKeyTravelStream(_rt: number, _batchSize?: number): AsyncIterable<KeyTravelList> {
    return this.unsupported('KeyTravelFeature.getKeyTravelStream')
  }
  setKeyTravel(_keyTravelList: KeyTravelWriteList, _index?: number): Promise<void[] | void> {
    return this.unsupported('KeyTravelFeature.setKeyTravel')
  }
  getKeyShaftTypes(): Promise<Array<{ index: number; shaftType: number }>> {
    return this.unsupported('KeyTravelFeature.getKeyShaftTypes')
  }
  setKeyShaftTypes(_entries: Array<{ index: number; shaftType: number }>): Promise<void> {
    return this.unsupported('KeyTravelFeature.setKeyShaftTypes')
  }
  getKeyShaftType(_keyIndex: number): Promise<number> {
    return this.unsupported('KeyTravelFeature.getKeyShaftType')
  }
  setKeyShaftType(_keyIndex: number, _shaftType: number): Promise<void> {
    return this.unsupported('KeyTravelFeature.setKeyShaftType')
  }
  getCalibrationValues(): Promise<GcomeCalibrationValue[]> {
    return this.unsupported('KeyTravelFeature.getCalibrationValues')
  }
  getCalibrationValuesQuick(): Promise<GcomeCalibrationValue[]> {
    return this.unsupported('KeyTravelFeature.getCalibrationValuesQuick')
  }
  getCalibrationCounts(): Promise<number[]> {
    return this.unsupported('KeyTravelFeature.getCalibrationCounts')
  }

  switchDemoMode(_state: boolean): Promise<void> {
    return this.unsupported('KeyTravelFeature.switchDemoMode')
  }
  switchCalibrationMode(_state: boolean, _options?: keyboardCalibration): Promise<void> {
    return this.unsupported('KeyTravelFeature.switchCalibrationMode')
  }
  calibration(_type: protocolCailbrationType, _keyList?: baseKeyMap): Promise<void> {
    return this.unsupported('KeyTravelFeature.calibration')
  }
  saveCalibration(_type: protocolCailbrationType): Promise<void> {
    return this.unsupported('KeyTravelFeature.saveCalibration')
  }
  switchAdaptiveCalibration(_state: boolean): Promise<void> {
    return this.unsupported('KeyTravelFeature.switchAdaptiveCalibration')
  }
}
